import { InfoCircle, XMark } from '@raydiant/raydial/components/Icons';
import { useState, useEffect } from 'react';

const MaintananceBanner = () => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const now = new Date();

    const targetTime = new Date('2025-06-09T23:59:59-07:00');

    const timeUntilTarget = targetTime.getTime() - now.getTime();

    if (timeUntilTarget > 0) {
      const timeout = setTimeout(() => {
        setIsOpen(false);
      }, timeUntilTarget);

      return () => clearTimeout(timeout);
    } else {
      setIsOpen(false);
    }
  }, []);

  const handleViewButtonClick = () => {
    window.open(
      'https://www.displai.ai/blog/meet-displai-the-next-chapter-for-raydiants-customers/',
      '_blank',
    );
  };

  return (
    <>
      {isOpen && (
        <div className="bg-[#ffcc00] p-2 flex items-center justify-center gap-1 relative">
          <InfoCircle size={20} />
          <span className="text-lg font-semibold text-black px-2">
            Meet Displai: The Next Chapter for Raydiant Customers!
          </span>
          <button
            className="bg-white rounded-3xl flex justify-center items-center h-6 w-11"
            onClick={() => handleViewButtonClick()}
          >
            <span className="text-sm font-bold text-black px-2 py-1">View</span>
          </button>
          <button
            className="absolute right-2.5"
            onClick={() => setIsOpen(false)}
          >
            <XMark />
          </button>
        </div>
      )}
    </>
  );
};

export default MaintananceBanner;
